import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  types,
  fetchHomeSuccess,
  fetchHomeError,
  getLimit,
  fetchNextPageSuccess,
  fetchNextPageError,
  setLatestPosts,
  setTrendPosts,
  setTopicPosts,
  getPageName,
  INIT_STATE,
} from '@blueberry/redux/home';
import { transformPages } from '@blueberry/redux/header';
import { actions as bannerActions } from '@blueberry/redux/banner';
import {
  actions as channelActions,
  transferChannelPosts,
} from '@blueberry/redux/channel';
import { getUserID } from '@blueberry/redux/profile';
import { actions as errorActions } from '@blueberry/redux/error';
import { getRegion } from '@blueberry/redux/locale';
import { changePosts } from '@blueberry/redux/pagePost';

import * as apis from '@blueberry/services/contents';

import { HOME } from '@blueberry/constants/subjectType';

export function* fetchHomeFlow(action) {
  try {
    const { name: pageName = HOME } = action.payload;

    const region = yield select(getRegion);
    // always fetch 1st page
    const page = INIT_STATE.page;
    const limit = yield select(getLimit);

    const {
      channels: channelResp,
      post: postResp,
      total_count: totalCount,
      related_pages: pages,
      related_posts: relatedPosts,
      display_name: displayName,
      id: homePageId,
    } = yield call(apis.getPageWithPaging, {
      name: pageName,
      region,
      page,
      limit,
    });

    const [latestPosts, trendPosts, topicPosts] = yield all([
      call(apis.getLatestPost, {
        page_id: homePageId,
      }),
      call(apis.getTrendPost, {
        page_id: homePageId,
      }),
      call(apis.getTopicPost, {
        page_id: homePageId,
      }),
    ]);

    yield put(
      setLatestPosts(latestPosts.map(apis.transferPostWithoutDescription))
    );
    yield put(
      setTrendPosts(trendPosts.map(apis.transferPostWithoutDescription))
    );
    yield put(
      setTopicPosts(topicPosts.map(apis.transferPostWithoutDescription))
    );

    // update banner when the banner is not empty
    if (postResp) {
      const banner = apis.transferPostWithoutDescription(postResp);
      yield put(bannerActions.changeBanner(banner));
    }
    // update channel

    const channels = channelResp.map(channel => ({
      id: channel.id,
      name: channel.title,
      posts: channel.posts.map(apis.transferPostWithoutDescription),
    }));

    const prunedChannels = transferChannelPosts(channels);
    yield put(channelActions.changeChannels(prunedChannels));
    // update posts
    const posts = relatedPosts.map(apis.transferPostWithoutDescription);
    yield put(changePosts(posts));

    const userId = yield select(getUserID);
    // always load more, if total count is more than channels count
    // always load more, if user login
    const needLoadMore = channels.length < totalCount || !!userId;

    yield put(
      fetchHomeSuccess({
        totalCount,
        needLoadMore,
        pageName,
        pages: transformPages(pages),
        displayName,
      })
    );
  } catch (err) {
    yield put(fetchHomeError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export function* fetchNextPageFlow() {
  try {
    const name = yield select(getPageName);
    const region = yield select(getRegion);

    const { channels: channelResp } = yield call(apis.getPage, {
      name,
      region,
    });

    // update channel
    const channels = channelResp.map(channel => ({
      id: channel.id,
      name: channel.title,
      posts: channel.posts.map(apis.transferPostWithoutDescription),
    }));

    const prunedChannels = transferChannelPosts(channels);
    yield put(channelActions.changeChannels(prunedChannels));

    yield put(fetchNextPageSuccess());
  } catch (err) {
    yield put(fetchNextPageError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(types.FETCH_HOME, fetchHomeFlow),
    takeLatest(types.FETCH_NEXT_PAGE, fetchNextPageFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/home.js